<maptio-error-page
  [iconName]="'surprise'"
  errorHeadline="A login error occurred"
  i18n-errorHeadline
></maptio-error-page>
